// /docs/:docId/review — glossary review: accept / edit / reject / publish.
// Figma frame 15 (33:4102). Owner: screens-content, US-121.
//
// This route was unreachable by URL for months (PRD 17 §1) and was fixed on
// 2026-08-15. The path and the exported name are unchanged, and
// `frontend/tests/routes.test.ts` still asserts both. `GlossaryReviewScreen`
// restyles `ReviewPage` for the paper chassis — it does not replace it.
//
// It hangs off the pathless shell layout so a `?org=` URL gets the sidebar and
// a bare one does not; the layout reads the same search param.

import { createRoute } from "@tanstack/react-router";
import { shellRoute } from "./_shell";
import { GlossaryReviewScreen } from "../screens/content/GlossaryReviewScreen";

export interface ReviewSearch {
  /** Which org's shell to draw. Absent on a bare direct URL — see the screen. */
  org?: string;
}

export const reviewRoute = createRoute({
  getParentRoute: () => shellRoute,
  path: "/docs/$docId/review",
  staticData: { title: "Glossary review" },
  // Additive and lossy on purpose: an unrecognised or empty `org` degrades to
  // "no org", which is the pre-PRD-18 rendering, never an error page.
  validateSearch: (search: Record<string, unknown>): ReviewSearch => ({
    org: typeof search.org === "string" && search.org ? search.org : undefined,
  }),
  component: ReviewRoute,
});

function ReviewRoute() {
  const { docId } = reviewRoute.useParams();
  const { org } = reviewRoute.useSearch();
  return <GlossaryReviewScreen docId={docId} orgSlug={org ?? null} />;
}
